import { BaseBroadcast } from "./BaseBroadcast";

type DataType = {
    id: number
}

export class ChatRoomSavedBroadcast extends BaseBroadcast {
    isPrivate = true;
    event = 'chat.room.saved';
    callback: (data: DataType) => void;

    constructor(callback: (data: DataType) => void) {
        super();
        this.setCallback(callback);
    }
}
